import React, { useState } from 'react';
import { Form, Input, Icon, message } from 'antd';
import Button from '../../../../../../components/Button/Button';
import TextEditor from '../../../../../../components/TextEditor/TextEditor';
// import AddressSearch from '../../../../components/AddressSearch/AddressSearch';

const FormItem = Form.Item;
const MAX_COUNT = 300;

const getWordCount = (str) => {
  if (!str) {
    return 0;
  }
  // remove all tags and replace them with spaces
  let content = str.replace(/<[^>]*>/g, ' ');
  if (content.trim() === '') {
    return 0;
  }
  // remove (trim) all left and right spaces
  content = content.replace(/\s+/g, ' ');
  content = content.trim();
  return content.split(' ').length;
};

const ProfileEdit = ({ form, isPrimary, companyProfile = {}, update, close }) => {
  const [wordCount, setWordCount] = useState(getWordCount(companyProfile.description));

  const { getFieldDecorator } = form;
  // const { street, postcode, suburb, state, country } = companyProfile.address || {};

  const submit = (e) => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (!err) {
        let data;
        if (isPrimary) {
          data = { ...values };
        } else {
          const { street = '', suburb = '', postcode = '', state = '', country = '' } = values;
          data = { ...values, address: { street, suburb, postcode, state, country } };
        }
        try {
          const res = await update(data);
          message.success(res);
        } catch (err) {
          message.error(err.message);
        }
        close();
      }
    });
  };

  // const onAddressChange = address => {
  //   const { street, suburb, state, postcode, country } = address;
  //   form.setFieldsValue({ street, suburb, state, postcode, country });
  // };

  const onAboutUsChange = (value) => {
    const count = getWordCount(value);
    setWordCount(count);
  };

  const validateAboutUs = (rule, value, callback) => {
    if (wordCount > MAX_COUNT) {
      callback(`The maximum number of words is ${MAX_COUNT}`);
    }
    callback();
  };

  return (
    <Form>
      {isPrimary ? null : (
        <FormItem>
          {getFieldDecorator('name', { initialValue: companyProfile.name })(
            <Input placeholder="Name" prefix={<Icon type="home" />} spellCheck={false} />
          )}
        </FormItem>
      )}
      {/* <Row gutter={20}>
        <Col xs={24} sm={16}>
          <FormItem>
            {getFieldDecorator('street', {
              initialValue: street,
              normalize: value => (typeof value === 'object' ? value.street : value)
            })(<AddressSearch placeholder="Address" prefix={<Icon type="environment" />} onChange={onAddressChange} />)}
          </FormItem>
        </Col>
        <Col xs={24} sm={8}>
          <FormItem>
            {getFieldDecorator('postcode', { initialValue: postcode })(<Input readOnly placeholder="Postcode" />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={20}>
        <Col xs={24} sm={8}>
          <FormItem>
            {getFieldDecorator('suburb', { initialValue: suburb })(<Input readOnly placeholder="City/Suburb" />)}
          </FormItem>
        </Col>
        <Col xs={24} sm={6}>
          <FormItem>
            {getFieldDecorator('state', { initialValue: state })(<Input readOnly placeholder="State" />)}
          </FormItem>
        </Col>
        <Col xs={24} sm={10}>
          <FormItem>
            {getFieldDecorator('country', { initialValue: country ? country.name : undefined })(
              <Input readOnly placeholder="Country (e.g., AU)" />
            )}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={20}>
        <Col xs={24} sm={12}>
          <FormItem>
            {getFieldDecorator('email', { initialValue: companyProfile.email })(
              <Input placeholder="Email" prefix={<Icon type="mail" />} spellCheck={false} />
            )}
          </FormItem>
        </Col>
        <Col xs={24} sm={12}>
          <FormItem>
            {getFieldDecorator('phone', { initialValue: companyProfile.phone })(
              <Input placeholder="Phone" prefix={<Icon type="phone" />} />
            )}
          </FormItem>
        </Col>
      </Row>
      <FormItem>
        {getFieldDecorator('registration_number', { initialValue: companyProfile.registration_number })(
          <Input placeholder="ABN" />
        )}
      </FormItem> */}
      <FormItem extra={`${wordCount}/${MAX_COUNT}`}>
        {getFieldDecorator('description', {
          initialValue: companyProfile.description,
          validateTrigger: ['onChange', 'onBlur', 'onFocus'],
          rules: [{ validator: validateAboutUs }],
        })(<TextEditor placeholder="About Us" autoSize={{ minRows: 2, maxRows: 6 }} onChange={onAboutUsChange} />)}
      </FormItem>
      <FormItem>
        <Button block type="primary" onClick={submit}>
          Save
        </Button>
      </FormItem>
    </Form>
  );
};

export default Form.create()(ProfileEdit);
